module.exports = __webpack_public_path__ + "static/media/Video-white.37861cab.svg";